import axios from 'axios'
import Api from '@/api.js'
import { getSTToken, doLogout, doSTLogout } from '@/services/AuthService'
import messageCodes from './message-codes'

const mainInstance = axios.create({
  baseURL: Api.API_BASE_URL
})

const stInstance = axios.create({
  baseURL: Api.ST_API_BASE_URL
})

export const http = {
  main: {
    token: '',
    post: function (url, data, options) {
      return mainInstance({
        url,
        data,
        method: 'post',
        headers: {
          authorization: options && options.token || this.token
        }
      })
    },
    get: function (url, options) {
      return mainInstance({
        url,
        method: 'get',
        headers: {
          authorization: options && options.token || this.token
        }
      })
    },
    setAuthToken: function (token) {
      this.token = 'Bearer ' + token
    },
    deleteAuthToken: function () {
      this.token = ''
    }
  },
  st: {
    token: 'UAT AF8mBSBkhvXDsrBWbvH5eGaPw4Gs7FGvhx89pKhF',
    post: function (url, data, options) {
      return stInstance({
        url,
        data,
        method: 'post',
        headers: {
          authorization: options && options.token || this.token
        }
      })
    },
    get: function (url, options) {
      return stInstance({
        url,
        method: 'get',
        headers: {
          authorization: options && options.token || this.token
        }
      })
    },
    setAuthToken: function (token) {
      this.token = 'UAT ' + token
    },
    deleteAuthToken: function () {
      this.token = ''
    }
  }
}

mainInstance.interceptors.response.use(
  function (res) {
    return new Promise(function (resolve, reject) {
      const data = res.data
      if (data && data.message)
        res.data.message = messageCodes[data.message] || messageCodes['unknown_message_type']
        //EventBus.$emit('SNACKBAR', res.data)
      resolve(res)
    })
  },
  function (err) {
    return new Promise(function (resolve, reject) {
      if (!err.response) {
        err.response = {data: {ok: false, message: 'no_response_from_server'}}
      }
      if (err.__CANCEL__)
        err.response.data.message = 'request_canceled_by_user'
      const resp = err.response
      if (resp.status === 401) {
        doLogout()
      }
      if (resp.data && resp.data.message) {
        const data = resp.data
        err.response.data.message = messageCodes[data.message] || messageCodes['unknown_error']
      }
      //EventBus.$emit('SNACKBAR', err.response.data)
      if (err.__CANCEL__)
        return resolve(err.response)
      throw err
    })
  }
)

stInstance.interceptors.response.use(
  function (res) {
    return new Promise(function (resolve, reject) {
      resolve(res)
    })
  },
  function (err) {
    return new Promise(function (resolve, reject) {
      if (err.response && err.response.status === 401) {
        doSTLogout()
      }
      reject(err)
    })
  }
)
